import React, { useState } from 'react';

export default function FeatureShowcase() {
  const [activeFeature, setActiveFeature] = useState(0);

  // Sample features data - replace with your actual data
  const features1 = [
    {
      id: 1,
      title: "Smart Recruitment",
      description: "AI-powered candidate matching and screening process",
      image: "https://images.unsplash.com/photo-1551434678-e076c223a692?w=600&h=400&fit=crop&q=80",
      icon: "📊"
    },
    {
      id: 2,
      title: "Applicant Tracking",
      description: "Track candidates through every stage of the hiring process",
      image: "https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop&q=80",
      icon: "👥"
    },
    {
      id: 3,
      title: "Analytics Dashboard",
      description: "Comprehensive insights into your recruitment metrics",
      image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop&q=80",
      icon: "📈"
    }
  ];

  return (
    <div className="feat-showcase-container">
      <style>{`
        .feat-showcase-container {
          max-width: 1400px;
          margin: 0 auto;
          padding: 80px 20px;
          background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
        }

        .feat-showcase-wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 60px;
          align-items: center;
          max-width: 1200px;
          margin: 0 auto;
        }

        /* Left Side - Image Display */
        .feat-image-section {
          position: relative;
        }

        .feat-image-card {
          background: white;
          border-radius: 20px;
          padding: 30px;
          box-shadow: 
            0 20px 60px rgba(0, 0, 0, 0.1),
            0 8px 30px rgba(0, 0, 0, 0.08);
          transform: perspective(1000px) rotateY(-5deg);
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
          border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .feat-image-card:hover {
          transform: perspective(1000px) rotateY(0deg) translateY(-10px);
          box-shadow: 
            0 30px 80px rgba(0, 0, 0, 0.15),
            0 15px 40px rgba(0, 0, 0, 0.1);
        }

        .feat-main-image {
          width: 100%;
          height: 400px;
          object-fit: cover;
          border-radius: 12px;
          transition: all 0.3s ease;
        }

        /* Right Side - Feature List */
        .feat-content-section {
          display: flex;
          flex-direction: column;
          gap: 25px;
        }

        .feat-item {
          display: flex;
          align-items: flex-start;
          gap: 20px;
          padding: 28px;
          background: rgba(255, 255, 255, 0.7);
          backdrop-filter: blur(10px);
          border-radius: 16px;
          cursor: pointer;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid transparent;
          position: relative;
          overflow: hidden;
        }

        .feat-item::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.4), transparent);
          transition: left 0.6s;
        }

        .feat-item:hover::before {
          left: 100%;
        }

        .feat-item:hover {
          background: rgba(255, 255, 255, 0.9);
          transform: translateX(10px);
          border-color: #4f46e5;
        }

        .feat-item.active {
          background: white;
          border-color: #4f46e5;
          box-shadow: 0 10px 30px rgba(79, 70, 229, 0.15);
          transform: translateX(10px);
        }

        .feat-icon {
          font-size: 2.5rem;
          padding: 12px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          border-radius: 12px;
          min-width: 60px;
          height: 60px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.3s ease;
        }

        .feat-item.active .feat-icon {
          transform: scale(1.1);
          background: linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%);
        }

        .feat-text {
          flex: 1;
        }

        .feat-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1a1a1a;
          margin-bottom: 8px;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          letter-spacing: -0.02em;
          line-height: 1.3;
        }

        .feat-description {
          font-size: 1.05rem;
          color: #666;
          line-height: 1.6;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
          font-weight: 400;
        }

        .feat-item.active .feat-title {
          color: #4f46e5;
          background: linear-gradient(135deg, #4f46e5, #7c3aed);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        /* Responsive Design */
        @media (max-width: 1024px) {
          .feat-showcase-wrapper {
            gap: 40px;
          }
          
          .feat-title {
            font-size: 1.3rem;
          }
          
          .feat-description {
            font-size: 1rem;
          }
        }

        @media (max-width: 768px) {
          .feat-showcase-container {
            padding: 60px 16px;
          }

          .feat-showcase-wrapper {
            grid-template-columns: 1fr;
            gap: 40px;
          }

          .feat-image-card {
            transform: none;
            padding: 20px;
          }

          .feat-image-card:hover {
            transform: translateY(-5px);
          }

          .feat-main-image {
            height: 300px;
          }

          .feat-item {
            padding: 20px;
          }

          .feat-item:hover {
            transform: translateX(5px);
          }

          .feat-item.active {
            transform: translateX(5px);
          }

          .feat-icon {
            font-size: 2rem;
            min-width: 50px;
            height: 50px;
          }
        }

        @media (max-width: 480px) {
          .feat-showcase-container {
            padding: 40px 12px;
          }

          .feat-item {
            flex-direction: column;
            text-align: center;
            gap: 15px;
          }

          .feat-icon {
            align-self: center;
          }
        }
      `}</style>

      <div className="feat-showcase-wrapper">
        {/* Left Side - Image Display */}
        <div className="feat-image-section">
          <div className="feat-image-card">
            <img 
              src={features1[activeFeature].image} 
              alt={features1[activeFeature].title}
              className="feat-main-image"
            />
          </div>
        </div>

        {/* Right Side - Feature List */}
        <div className="feat-content-section">
          {features1.map((feature1, index) => (
            <div
              key={feature1.id}
              className={`feat-item ${activeFeature === index ? 'active' : ''}`}
              onClick={() => setActiveFeature(index)}
            >
              <div className="feat-icon">{feature1.icon}</div>
              <div className="feat-text">
                <h3 className="feat-title">{feature1.title}</h3>
                <p className="feat-description">{feature1.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}